import { render, staticRenderFns } from "./PaidDaysOff.vue?vue&type=template&id=623ba6b0&scoped=true&"
import script from "./PaidDaysOff.vue?vue&type=script&lang=js&"
export * from "./PaidDaysOff.vue?vue&type=script&lang=js&"
import style0 from "./PaidDaysOff.vue?vue&type=style&index=0&id=623ba6b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "623ba6b0",
  null
  
)

export default component.exports